/**
 * MessagesHeaderButton — Core Frontend wrapper (Story 2.3.6.5 → 2.3.6.13 DRY)
 *
 * Thin wrapper around shared-ui-lib MessagesHeaderButton. Since MSG-INBOX-TABS.6 (AC-4) it
 * shows dots, not a number: blue — unread in «Personal», yellow — unread in some shop, both
 * overlapping. The label names where the unread is, so colour is not the only signal.
 */

import { MessagesHeaderButton as SharedMessagesHeaderButton } from '@teletienda/shared-ui-lib';
import { useTranslation } from 'react-i18next';
import { useUnreadCounts } from '@/hooks/useConversations';
import { headerUnreadDots } from '@/lib/messenger/inboxContext';

const NO_DOTS = { personal: false, shops: false };

export function MessagesHeaderButton() {
  const { t } = useTranslation('common');
  const { data: dots = NO_DOTS } = useUnreadCounts(headerUnreadDots);

  const label =
    dots.personal && dots.shops
      ? t('messages.header_unread_both')
      : dots.personal
        ? t('messages.header_unread_personal')
        : dots.shops
          ? t('messages.header_unread_shops')
          : t('messages.title');

  return <SharedMessagesHeaderButton unreadDots={dots} to="/messages" label={label} />;
}
